import React from 'react';

import { Row, Card } from 'reactstrap';

import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { TotalRegister } from '../../../../../components/TotalRegister';
import {
  individual_column_style,
  individual_header_style
} from '../../../../../assets/styles/table_custom_style';

const analytical = (props) => {
  return (
    <>
      <Row>
        <div className="col">
          <div className="card-wrapper">
            {props.totalRegister >= 0 && (
              <TotalRegister totalRegister={props.totalRegister} />
            )}
            <Card>
              <ToolkitProvider
                data={props.showReports}
                keyField="uuid"
                columns={[
                  {
                    dataField: 'agentName',
                    text: 'Agente',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },

                  ...(props.agentCode
                    ? [
                        {
                          dataField: 'agentCode',
                          text: 'Código do Agente',
                          sort: true,
                          style: individual_column_style,
                          headerStyle: individual_header_style
                        }
                      ]
                    : []),
                  {
                    dataField: 'dateIn',
                    text: 'Login inicial',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'dateOut',
                    text: 'Login final',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'timeLogin',
                    text: 'Tempo logado',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'qtdLogin',
                    text: 'Quantidade de logins',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'qtdCallIn',
                    text: 'Quantidade de ligação recebidas',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'qtdCallOut',
                    text: 'Quantidade de ligação realizadas',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'avgNps',
                    text: 'Média Satisfação NPS',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },

                  {
                    dataField: 'avgSatisfaction',
                    text: 'Média Satisfação CSAT',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'npsCount',
                    text: 'Quantidade de pesquisa NPS',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'satisfactionCount',
                    text: 'Quantidade de pesquisa CSAT',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'timePause',
                    text: 'Tempo em pausa',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'qtdPause',
                    text: 'Quantidade de pausa',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'attendanceReceived',
                    text: 'Tempo em ligação recebidas',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'attendanceOrigin',
                    text: 'Tempo em ligação originada',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'attendanceTotal',
                    text: 'Tempo total em ligação',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'timeFree',
                    text: 'Tempo livre',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'percentBusy',
                    text: 'Ocupado',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'percentPause',
                    text: 'Em pausa',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'percentFree',
                    text: 'Livre',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  }
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      classes="align-items-center"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </div>
        </div>
      </Row>
    </>
  );
};
export default analytical;
